import { Text } from '@dixa/lib-shared-habla';

/** Details for claimed authentication. */
export function VerifiedDetails(): JSX.Element {
  return (
    <Text.Paragraph>
      The <strong>Programmatic user authentication</strong> configuration below
      is required. An icon is displayed in the agent interface to indicate that
      the user has been automatically authenticated by the system.
    </Text.Paragraph>
  );
}
